'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { BlockStack, Box, Scrollable, Text } from '@shopify/polaris';
import { useUserStore } from '@/providers/userStoreProvider';
import { MAIN_NAVIGATION_ITEMS } from './constants';
import ShopifyStoreSelector from '@/components/shopify/ShopifyStoreSelector';
import SignOutButton from '@/features/auth/SignOutButton';
import NavItem from './NavigationItem';

type NavigationProps = React.HTMLAttributes<HTMLDivElement>;

const Navigation: React.FC<NavigationProps> = ({ className }) => {
  const { account } = useUserStore((state) => state);
  return (
    <div className={cn(className, 'grid content-between gap-2 pt-3')}>
      <Scrollable>
        <nav className="space-y-2">
          <section className="space-y-1">
            {MAIN_NAVIGATION_ITEMS.map((item) => (
              <NavItem key={item.href} href={item.href} icon={item.icon}>
                {item.title}
              </NavItem>
            ))}
          </section>
        </nav>
      </Scrollable>

      <BlockStack gap="200">
        <ShopifyStoreSelector />

        <Box padding="100" paddingInline="500">
          <Text
            as="h3"
            variant="headingMd"
            fontWeight="semibold"
            tone="subdued"
          >
            {account?.name}
          </Text>
        </Box>

        <Box padding="100" paddingInline="300">
          <SignOutButton />
        </Box>
      </BlockStack>
    </div>
  );
};

export default Navigation;
